// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiInput-underline:hover::before {
    border-color: rgb(99, 79, 125) !important;
}

.MuiAutocomplete-popper > .MuiAutocomplete-paper {
    box-shadow: rgba(0, 0, 0, 0.25) -4px 0 5px -2px,
                rgba(0, 0, 0, 0.25) 4px 0 5px -2px,
                rgba(0, 0, 0, 0.25) 0 4px 5px -2px;
}
#description-input:focus {
    border: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/LaptopReplacementModal/component/ReasonInput/index.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;;AAEA;IACI;;kDAE8C;AAClD;AACA;IACI,uBAAuB;AAC3B","sourcesContent":[".MuiInput-underline:hover::before {\n    border-color: rgb(99, 79, 125) !important;\n}\n\n.MuiAutocomplete-popper > .MuiAutocomplete-paper {\n    box-shadow: rgba(0, 0, 0, 0.25) -4px 0 5px -2px,\n                rgba(0, 0, 0, 0.25) 4px 0 5px -2px,\n                rgba(0, 0, 0, 0.25) 0 4px 5px -2px;\n}\n#description-input:focus {\n    border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
